import {View, StyleSheet, Dimensions} from 'react-native';
import React from 'react';
import {appBackground} from '../../utils/utils';
import {useSelector} from 'react-redux';
import {selectLandscapeSmallWebView} from '../../redux/slices/ScreenOrientationSlice';
// import {Document, Page, pdfjs} from 'react-pdf';

const {width, height} = Dimensions.get('window');
const WebView = props => {
   const urlPath = props.source.uri;
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const styles = {
      container: {
         width: '100%',
         height: '88vh',
         backgroundColor: appBackground,
         justifyContent: 'center',
         alignItems: 'center',
         borderColor: 'none',
         borderWidth: 0,
         minWidth: isLandscapeSmallWebView ? '100vh' : '100vw',
         minHeight: isLandscapeSmallWebView ? '100vw' : '95%',
      },
   };
   return (
      <View style={styles.container}>
         <iframe
            src={urlPath || 'https://www.norcat.org'}
            width={width - 5}
            height={height}
            className={isLandscapeSmallWebView ? 'iframe_landscape' : 'iframe'}
         />
      </View>
   );
};
export default WebView;
